<div class="row">
    <div class="col-8">
        <div class="mb-3">
            <label class="form-label" for="url">URL</label>
            <input type="text" name="url" id="url" class="form-control" [(ngModel)]="pregunta.Url"
                   [disabled]="accesoPublico">
        </div>
    </div>
    <div class="col-4">
        <div class="mb-3">
            <label class="form-label" for="tiempomin">Tiempo mínimo</label>
            <input type="number" min="0" name="tiempomin" id="tiempomin" class="form-control"
                [(ngModel)]="pregunta.TiempoMinimo" [disabled]="accesoPublico">
        </div>
    </div>
</div>
